import { createFileRoute } from "@tanstack/react-router";
import { loadContentMeta, buildContentHead } from "@/lib/seo/contentHead";
import CasosDeEstudioSlugRedirect from "@/components/LegacyRedirects";

export const Route = createFileRoute("/es/casos-de-estudio/$slug")({
  loader: ({ params }) => loadContentMeta("case_studies", params.slug, "es"),
  head: ({ params, loaderData }) =>
    buildContentHead(`/es/casos-de-estudio/${params.slug}`, loaderData),
  component: CasosDeEstudioSlugRedirect,
});

